<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <app-sub-title text="Filtros"></app-sub-title>
            </b-col>
        </b-row>
        <b-row row wrap>
            <b-col cols="12" md="3">
                <app-autocomplete
                    :items="clients"
                    v-model="filters.clientId"
                    key-prop="id"
                    placeholder="Cliente"
                    :get-object="false"
                />
            </b-col>
            <b-col cols="12" md="3">
                <app-autocomplete
                    :items="executives"
                    v-model="filters.executiveId"
                    placeholder="Ejecutivo"
                    :get-object="false"
                />
            </b-col>
            <b-col cols="12" md="3">
                <b-row>
                    <b-col cols="12" md="3">
                        <b-btn
                            variant="primary"
                            block
                            @click="$emit('filter', filters)"
                            ><i class="fa fa-filter"></i
                        ></b-btn>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-btn variant="secondary" block @click="onClearFilters"
                            ><i class="fa fa-times-circle"></i
                        ></b-btn>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'round_filters',
    data: () => ({
        selectedClient: '',
        executive: '',
        filters: {
            clientId: '',
            executiveId: '',
        },
        // clients: [],
    }),
    watch: {
        // selectedClient(client) {
        //     this.filters.clientId = client.id;
        // },
        executive(executive) {
            this.filters.executiveId = executive.id
        },
    },
    computed: {
        ...mapGetters(['clients', 'executives']),
    },
    methods: {
        onClearFilters() {
            this.filters = {
                clientId: '',
                executiveId: '',
            }
            this.$emit('filter', this.filters)
        },
        async loadClientList() {
            const { data } = await repo.get('list/clients')
            this.clients = data
        },
    },
    mounted() {
        this.load('clients')
        this.load('executives')
        // this.loadClientList()
    },
}
</script>
